var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollaborators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7a2.5 2.5 0 1 1 0-5 2.5 2.5 0 1 1 0 5zm2.5 1.667a2.5 2.5 0 0 1 2.5 2.5v5h-2.5v5c0 .46-.373.833-.833.833h-3.334a.834.834 0 0 1-.833-.833v-5H7v-5a2.5 2.5 0 0 1 2.5-2.5h5zm-8.312 0a4.14 4.14 0 0 0-.847 2.245l-.008.255v6.666H7V19.5a.834.834 0 0 1-.729.827l-.104.006H4.5a.834.834 0 0 1-.827-.729l-.006-.104v-4.167H2v-5c0-.872.67-1.587 1.523-1.66l.144-.006h2.521zm14.145 0c.921 0 1.667.745 1.667 1.666v5h-1.667V19.5c0 .46-.373.833-.833.833h-1.667A.834.834 0 0 1 17 19.5v-1.667h1.667v-6.666c0-.942-.326-1.802-.855-2.5h2.521zm-15-.834a1.666 1.666 0 1 1 0-3.333 1.666 1.666 0 1 1 0 3.333zm13.334 0a1.666 1.666 0 1 0 0-3.333 1.666 1.666 0 1 0 0 3.333z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborators);
export default __webpack_public_path__ + "static/media/collaborators.d59489aad7ef6f74849dfcfa6193b3b4.svg";
export { ForwardRef as ReactComponent };